import { useQuery } from "@tanstack/react-query";
import {
  TMSPalletSearchParams,
  TMSPalletStatus,
  TMSPalletVo,
} from "@/types/tms";
import { ColDef } from "node_modules/ag-grid-community/dist/types/core/entities/colDef";
import { queryPallets as queryTMSPallets } from "@/apis/tms/pallet";
import { ICellRendererParams } from "node_modules/ag-grid-community/dist/types/core/rendering/cellRenderers/iCellRenderer";
import { Tag } from "antd";

export function useTMSPallets(query: TMSPalletSearchParams) {
  return useQuery({
    queryKey: ["tms-pallets", query],
    queryFn: () => queryTMSPallets(query),
  });
}

const PalletStatusColorMap: Record<TMSPalletStatus, string> = {
  [TMSPalletStatus.Upcoming]: "orange",
  [TMSPalletStatus.OnStack]: "green",
  [TMSPalletStatus.OffStack]: "green",
  [TMSPalletStatus.OnStage]: "purple",
  [TMSPalletStatus.Shipping]: "blue",
  [TMSPalletStatus.Delivered]: "gray",
  [TMSPalletStatus.Deleted]: "red",
  [TMSPalletStatus.Working]: "orange",
};

export const OrderProcessPalletCols: ColDef<TMSPalletVo>[] = [
  {
    headerName: "No",
    field: "no",
    resizable: true,
    minWidth: 150,
    maxWidth: 150,
    suppressMenu: true,
    rowDrag: false,
    pinned: "left",
  },
  {
    headerName: "Products",
    field: "scannedCartonSkus",
    resizable: true,
    minWidth: 120,
    flex: 1,
    suppressMenu: true,
    rowDrag: false,
    cellRenderer: ({ data }: ICellRendererParams<TMSPalletVo, string>) => {
      const items = [...(data!.scannedCartonSkus ?? [])];
      const rows = Math.ceil(items.length / 2);
      return (
        <div className="flex flex-col gap-1">
          {Array.from({ length: rows }).map((_, index) => (
            <div key={index} className="flex flex-row">
              {items.slice(index * 2, (index + 1) * 2).map((sku, index) => (
                <Tag color="blue" key={index}>
                  {sku}
                </Tag>
              ))}
            </div>
          ))}
        </div>
      );
    },
  },
  {
    headerName: "Status",
    field: "status",
    resizable: true,
    minWidth: 120,
    maxWidth: 120,
    suppressMenu: true,
    rowDrag: false,
    cellRenderer: ({ data }: ICellRendererParams<TMSPalletVo, string>) => {
      return (
        <Tag color={PalletStatusColorMap[data!.status]}>{data!.status}</Tag>
      );
    },
  },
  {
    headerName: "Quantity",
    field: "quantity",
    resizable: false,
    minWidth: 120,
    maxWidth: 120,
    suppressMenu: true,
    rowDrag: false,
  },
];

export interface PalletsTableRef {
  refresh: () => void;
}
